import React, { useState } from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { t } from 'i18next';
import Button from '@mui/material/Button';
import { MODULES } from '../adminComponents/adminConstants';

interface TemporaryDrawerProps {
  setShowAddTariff: any,
  refreshTariff: any,
}

export default function AddTariff({ setShowAddTariff, refreshTariff }: TemporaryDrawerProps) {
  const handleClose = () => setShowAddTariff(false);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [monthlyPrice, setMonthlyPrice] = useState();
  const [yearlyPrice, setYearlyPrice] = useState();
  const [trialDays, setTrialDays] = useState();
  const [maxUsers, setMaxUsers] = useState();
  const [maxStorage, setMaxStorage] = useState();
  const [maxProjects, setMaxProjects] = useState();
  const [hasBranding, setHasBranding] = useState(false);
  const [prioritySupport, setPrioritySupport] = useState(false);
  const [hasApiAccess, sethasApiAccess] = useState(false);
  const [hasIntegrations, setHasIntegrations] = useState(false);
  const [allowedModules, setAllowedModules] = useState<string[]>([]);
  const { enqueueSnackbar } = useSnackbar();

  const handleTariff = async () => {
    try {
      if (!name.trim()) {
        return enqueueSnackbar('Name is required', { variant: 'error' });
      }
      if (!description.trim()) {
        return enqueueSnackbar('Description is required', { variant: 'error' });
      }

      let payload: any = {
        name,
        description,
        monthly_price: Number(monthlyPrice),
        yearly_price: Number(yearlyPrice),
        trial_days: Number(trialDays),
        has_branding: hasBranding,
        priority_support: prioritySupport,
        max_users: Number(maxUsers),
        max_storage: Number(maxStorage),
        max_projects: Number(maxProjects),
        has_api_access: hasApiAccess,
        has_integrations: hasIntegrations,
        allowed_modules: allowedModules,
      };

      await axios.post(`tariff/add`, payload);
      handleClose();
      refreshTariff();
      enqueueSnackbar('Successfully', { variant: 'success' });
    } catch (error) {
      enqueueSnackbar('Error creating', { variant: 'error' });
      console.error('Error creating:', error);
    }
  };

  return (
    <Box sx={{
      width: 420,
      height: '200%',
      background: 'var(--bg-form)'
    }}
      role="presentation">
      <List>
        <div className='my-[5px] mx-[25px] text-[var(--text-color)]' id='reg-user-edit'>
          <div className='flex justify-end'>
            <h1 className='text-[20px] text-left font-bold'>{t('AddTariff')}</h1>
          </div>
          <div className='flex flex-col justify-evenly flex-grow' >
            <hr className='hr mt-[10px]' />
            <h2 className='text-[14px] my-[5px] font-semibold text-right'>{t('Information')}</h2>
            <div className='flex flex-col gap-[5px] mt-[5px]'>
              <div className='flex flex-col w-full'>
                <label className='text-[10px] ml-[5px]'>{t('Name')}:</label>
                <input type="text"
                  value={name || ''}
                  className="w-full rounded-[5px] edit-input"
                  onChange={(e: any) => setName(e.target.value)}
                />
              </div>
              <div className='flex flex-col w-full'>
                <label className='text-[10px] ml-[5px]'>{t('Description')}:</label>
                <input type="text"
                  value={description || ''}
                  className="w-full rounded-[5px] edit-input"
                  onChange={(e: any) => setDescription(e.target.value)}
                />
              </div>
            </div>
            <hr className='hr mt-1 mb-[5px]' />
            <div className='flex gap-[5px] mt-[5px]'>
              <div className='flex flex-col w-full'>
                <label className='text-[10px] ml-[5px]'>{t('MonthlyPrice')}:</label>
                <input type="text"
                  value={monthlyPrice || ''}
                  className="w-full rounded-[5px] edit-input text-right"
                  onChange={(e: any) => {
                    let value = e.target.value;
                    value = value.replace(/[^0-9.]/g, '');
                    if ((value.match(/\./g) || []).length > 1) {
                      value = value.slice(0, -1);
                    }
                    setMonthlyPrice(value);
                  }}
                />
              </div>
              <div className='flex flex-col w-full'>
                <label className='text-[10px] ml-[5px]'>{t('YearlyPrice')}:</label>
                <input type="text"
                  value={yearlyPrice || ''}
                  className="w-full rounded-[5px] edit-input text-right"
                  onChange={(e: any) => {
                    let value = e.target.value;
                    value = value.replace(/[^0-9.]/g, '');
                    if ((value.match(/\./g) || []).length > 1) {
                      value = value.slice(0, -1);
                    }
                    setYearlyPrice(value);
                  }}
                />
              </div>
              <div className='flex flex-col w-full'>
                <label className='text-[10px] ml-[5px]'>{t('TrialDays')}:</label>
                <input type="text"
                  value={trialDays || ''}
                  className="w-full rounded-[5px] edit-input text-right"
                  onChange={(e: any) => {
                    let value = e.target.value;
                    value = value.replace(/[^0-9.]/g, '');
                    if ((value.match(/\./g) || []).length > 1) {
                      value = value.slice(0, -1);
                    }
                    setTrialDays(value);
                  }}
                />
              </div>
            </div>
            <div className='flex gap-[5px] mt-[5px]'>
              <div className='flex flex-col w-full'>
                <label className='text-[10px] ml-[5px]'>{t('MaxUsers')}:</label>
                <input type="text"
                  value={maxUsers || ''}
                  className="w-full rounded-[5px] edit-input text-right"
                  onChange={(e: any) => {
                    let value = e.target.value;
                    value = value.replace(/[^0-9.]/g, '');
                    if ((value.match(/\./g) || []).length > 1) {
                      value = value.slice(0, -1);
                    }
                    setMaxUsers(value);
                  }}
                />
              </div>
              <div className='flex flex-col w-full'>
                <label className='text-[10px] ml-[5px]'>{t('MaxStorage')}:</label>
                <input type="text"
                  value={maxStorage || ''}
                  className="w-full rounded-[5px] edit-input text-right"
                  onChange={(e: any) => {
                    let value = e.target.value;
                    value = value.replace(/[^0-9.]/g, '');
                    if ((value.match(/\./g) || []).length > 1) {
                      value = value.slice(0, -1);
                    }
                    setMaxStorage(value);
                  }}
                />
              </div>
              <div className='flex flex-col w-full'>
                <label className='text-[10px] ml-[5px]'>{t('MaxProjects')}:</label>
                <input type="text"
                  value={maxProjects || ''}
                  className="w-full rounded-[5px] edit-input text-right"
                  onChange={(e: any) => {
                    let value = e.target.value;
                    value = value.replace(/[^0-9.]/g, '');
                    if ((value.match(/\./g) || []).length > 1) {
                      value = value.slice(0, -1);
                    }
                    setMaxProjects(value);
                  }}
                />
              </div>
            </div>
            <hr className='hr mt-1 mb-[5px]' />
            <div className='ml-[10px] flex gap-[10px] justify-start items-center my-[10px]'>
              <input id="add-tariff-branding"
                type="checkbox"
                checked={hasBranding || false}
                onChange={(e) => setHasBranding(e.target.checked)} />
              <label htmlFor="add-tariff-branding" className='text-[14px]'>{t('HasBranding')}</label>
            </div>
            <div className='ml-[10px] flex gap-[10px] justify-start items-center my-[10px]'>
              <input id="add-tariff-priority"
                type="checkbox"
                checked={prioritySupport || false}
                onChange={(e) => setPrioritySupport(e.target.checked)} />
              <label htmlFor="add-tariff-priority" className='text-[14px]'>{t('PrioritySupport')}</label>
            </div>
            <div className='ml-[10px] flex gap-[10px] justify-start items-center my-[10px]'>
              <input id="add-tariff-api"
                type="checkbox"
                checked={hasApiAccess || false}
                onChange={(e) => sethasApiAccess(e.target.checked)} />
              <label htmlFor="add-tariff-api" className='text-[14px]'>{t('HasApiAccess')}</label>
            </div>
            <div className='ml-[10px] flex gap-[10px] justify-start items-center my-[10px]'>
              <input id="add-tariff-integrations"
                type="checkbox"
                checked={hasIntegrations || false}
                onChange={(e) => setHasIntegrations(e.target.checked)} />
              <label htmlFor="add-tariff-integrations" className='text-[14px]'>{t('HasIntegrations')}</label>
            </div>
            <hr className='hr mt-1 mb-[5px]' />
            <h2 className='text-[14px] my-[5px] font-semibold text-right'>Modules</h2>
            <div className='grid grid-cols-2 gap-[4px] mt-[5px]'>
              {MODULES.map(mod => (
                <label key={mod} htmlFor={`mod-${mod}`} className='flex items-center gap-[8px] px-[8px] py-[5px] rounded-[5px] border border-[var(--border-input)] cursor-pointer hover:bg-[var(--bg-input)]'>
                  <input
                    id={`mod-${mod}`}
                    type="checkbox"
                    checked={allowedModules.includes(mod)}
                    onChange={() => setAllowedModules(prev =>
                      prev.includes(mod) ? prev.filter(m => m !== mod) : [...prev, mod]
                    )}
                  />
                  <span className='text-[13px] capitalize'>{mod}</span>
                </label>
              ))}
            </div>
            <hr className='hr mt-[10px] mb-[10px]' />
            <div className='flex mt-[20px] justify-center items-center gap-[10px]'>
              <Button
                variant="contained"
                sx={{
                  padding: '5px 10px',
                  fontSize: 14,
                  width: '100%',
                  color: 'white !important'
                }}
                onClick={() => handleTariff()}
              >
                {t('Create')}
              </Button>
              <Button
                variant="contained"
                sx={{
                  padding: '5px 10px',
                  fontSize: 14,
                  width: '100%',
                  color: 'white !important'
                }}
                onClick={() => setShowAddTariff(false)}>
                {t('Cancel')}
              </Button>
            </div>
          </div>
        </div>
      </List>
    </Box>
  )
}